/**
 * Get in touch: a message from the Contact page to the club's inbox.
 * The server emails info@carolinasoccerfactory.com with Reply-To set to
 * the sender, and fails loudly if the email could not be sent.
 */

import apiClient from "../client";
import { API_ENDPOINTS } from "../../constants/api.constants";

const contactService = {
  /** @param {{first_name: string, last_name: string, email: string, message: string}} data */
  send: async (data) => {
    const { data: result } = await apiClient.post(API_ENDPOINTS.CONTACT.SEND, data);
    return result;
  },
};

export default contactService;
